/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VisitShouldBeCompletedBy
 */
export interface VisitShouldBeCompletedBy {
}

/**
 * Check if a given object implements the VisitShouldBeCompletedBy interface.
 */
export function instanceOfVisitShouldBeCompletedBy(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VisitShouldBeCompletedByFromJSON(json: any): VisitShouldBeCompletedBy {
    return VisitShouldBeCompletedByFromJSONTyped(json, false);
}

export function VisitShouldBeCompletedByFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitShouldBeCompletedBy {
    return json;
}

export function VisitShouldBeCompletedByToJSON(value?: VisitShouldBeCompletedBy | null): any {
    return value;
}

